(function () {
  function hideLegacyHomepageNav() {
    if (!document.body || !document.body.classList.contains('template-index')) return;
    document
      .querySelectorAll(
        '#header-group .header-section, #header-group .header-section .header__row, #header-component'
      )
      .forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('max-height', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      });
  }

  hideLegacyHomepageNav();
  document.addEventListener('DOMContentLoaded', hideLegacyHomepageNav);

  var userScrolling = false;
  var scrollEndTimer = 0;
  var pendingRender = null;

  window.addEventListener(
    'scroll',
    function () {
      userScrolling = true;
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(function () {
        userScrolling = false;
        document.querySelectorAll("[id^='nuvra-just-sold-']").forEach(function (root) {
          if (root.__nuvraFlushPending) root.__nuvraFlushPending();
        });
      }, 250);
    },
    { passive: true }
  );

  document.querySelectorAll("[id^='nuvra-just-sold-']").forEach(initBanner);

  function initBanner(root) {
    var track = root.querySelector("[data-just-sold-track]");
    if (!track) return;

    var API_BASE = (root.dataset.apiBase || "").replace(/\/$/, "");
    var pollSeconds = Math.max(10, Number(root.dataset.pollSeconds || 20));
    var knownIds = new Set();
    var sales = [];
    var hasRealSales = false;

    track.querySelectorAll("[data-sale-id]").forEach(function (el) {
      if (el.getAttribute("aria-hidden") !== "true") {
        knownIds.add(el.dataset.saleId);
      }
    });

    track.addEventListener("mouseenter", function () {
      track.classList.add("is-paused");
    });
    track.addEventListener("mouseleave", function () {
      track.classList.remove("is-paused");
    });

    function esc(str) {
      var d = document.createElement("div");
      d.textContent = str == null ? "" : String(str);
      return d.innerHTML;
    }

    function itemHtml(sale, isNew, hidden) {
      var hiddenAttr = hidden ? ' aria-hidden="true"' : "";
      return (
        '<span class="nuvra-just-sold__item' +
        (isNew ? " is-new" : "") +
        '"' +
        hiddenAttr +
        ' data-sale-id="' +
        esc(sale.id) +
        '" data-sold-at="' +
        esc(sale.soldAt || "") +
        '">' +
        '<span class="nuvra-just-sold__dot" aria-hidden="true"></span>' +
        esc(sale.message) +
        "</span>"
      );
    }

    function renderTrack(newFrontIds) {
      if (!sales.length) return;
      if (userScrolling) {
        pendingRender = newFrontIds;
        root.__nuvraFlushPending = function () {
          if (pendingRender !== null) {
            var ids = pendingRender;
            pendingRender = null;
            renderTrack(ids);
          }
        };
        return;
      }
      pendingRender = null;

      var first = sales
        .map(function (sale) {
          return itemHtml(sale, newFrontIds && newFrontIds.has(sale.id), false);
        })
        .join("");

      var second = sales
        .map(function (sale) {
          return itemHtml(sale, false, true);
        })
        .join("");

      track.classList.add("is-resetting");
      track.innerHTML = first + second;

      requestAnimationFrame(function () {
        track.classList.remove("is-resetting");
      });

      if (newFrontIds && newFrontIds.size) {
        setTimeout(function () {
          track.querySelectorAll(".is-new").forEach(function (el) {
            el.classList.remove("is-new");
          });
        }, 2600);
      }
    }

    function applyIncoming(incoming) {
      var newFrontIds = new Set();
      var next = sales.slice();

      incoming.forEach(function (sale) {
        if (!knownIds.has(sale.id)) {
          next.unshift(sale);
          knownIds.add(sale.id);
          newFrontIds.add(sale.id);
        }
      });

      if (!newFrontIds.size && incoming.length && next.length) {
        var latest = incoming[0];
        if (latest && next[0] && next[0].id !== latest.id) {
          next = next.filter(function (s) {
            return s.id !== latest.id;
          });
          next.unshift(latest);
          newFrontIds.add(latest.id);
        }
      }

      sales = next.slice(0, 30);
      return newFrontIds;
    }

    async function fetchSales() {
      if (!API_BASE) return;

      try {
        var res = await fetch(API_BASE + "/api/sales/recent?limit=12", { cache: "no-store" });
        if (!res.ok) return;
        var data = await res.json();
        if (!data.sales || !data.sales.length) return;

        if (!hasRealSales) {
          hasRealSales = true;
          sales = data.sales.slice(0, 30);
          knownIds = new Set(sales.map(function (s) { return s.id; }));
          /* Keep seed HTML — only re-render when new sales arrive (avoids top-of-page jump) */
          return;
        }

        var newFrontIds = applyIncoming(data.sales);
        if (newFrontIds.size) {
          renderTrack(newFrontIds);
        }
      } catch (_) {
        /* keep seed content */
      }
    }

    if (API_BASE) {
      fetchSales();
      setInterval(fetchSales, pollSeconds * 1000);
    }
  }
})();
